import { AxiosError } from 'axios'
import { flow, makeObservable } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { searchQueryConfig } from 'Core/constants/filters'
import { CoreUrlParams, SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'

import { UrlParams } from 'Portals/Supplier/constants'
import { Report } from 'Portals/Supplier/entities'
import {
	getFilterConfig,
	mainSearchConfig
} from 'Portals/Supplier/Pages/Report/TableList/Filters/utils/config'
import { ReportRepo } from 'Portals/Supplier/repositories'
import { RootStore } from 'Portals/Supplier/stores'

const STORAGE_REPORT_PAGE_SIZE = 'is2/reportPageSize'

export class ReportTable extends TableStore<Report.Basic> {
	constructor(public rootStore: RootStore) {
		super(STORAGE_REPORT_PAGE_SIZE)
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams) {
		try {
			yield this.requestData({
				defaultSort,
				repository: ReportRepo.getList
			})
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}

	initFromURLParams = (params: Record<string, string[]>) => {
		const searchKeys = [UrlParams.reportName, CoreUrlParams.searchQuery]

		const filterKeys = [UrlParams.startDate, UrlParams.endDate, UrlParams.status]

		const mergedSearchConfig = {
			...mainSearchConfig,
			...searchQueryConfig
		}

		this.initSearchParamsFromUrl(params, searchKeys, mergedSearchConfig)
		this.initFilterParamsFromUrl(params, filterKeys, getFilterConfig())
	}

	reset = () => {
		this.resetTable()
	}
}
